module.exports = __webpack_public_path__ + "img/carrousel-captores-2.81503bf1.jpg";